/* __next_internal_client_entry_do_not_use__ SDUIFilterablePaginatedSectionNavigationLink auto */ import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { navigationLinkWrapper, navigationLinkBorderBottom, navigationLinkText, subCategoriesLinkWrapper } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/styles.css";
import { useCategoryNavigationPrefetch } from "@faire/retailer-visitor-shared/lib/useCategoryNavigationPrefetch";
import { assignSettingOnEvent } from "@faire/retailer-visitor-shared/settings/assignSettingOnEvent";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { trackCategoriesSideNavigationClick } from "@faire/web-api--source/events/categories/click/sideNavigation";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import React from "react";
export var SDUIFilterablePaginatedSectionNavigationLink = function(param) {
    var navigationTreeLink = param.navigationTreeLink;
    var viewRef = useDoActionWhenVisible(function() {
        navigationTreeLink.identifiers_for_assignment.forEach(function(setting) {
            return assignSettingOnEvent(setting);
        });
    });
    var _useCategoryNavigationPrefetch = useCategoryNavigationPrefetch(), prefetchOnMouseEnter = _useCategoryNavigationPrefetch.prefetchOnMouseEnter, prefetchOnTouchStart = _useCategoryNavigationPrefetch.prefetchOnTouchStart, clearPrefetchTimeoutOnBlur = _useCategoryNavigationPrefetch.clearPrefetchTimeoutOnBlur;
    var _navigationTreeLink_url, _navigationTreeLink_name;
    return /*#__PURE__*/ _jsxs(Column, {
        align: "flex-start",
        justify: "flex-start",
        children: [
            /*#__PURE__*/ _jsx(Link, {
                to: (_navigationTreeLink_url = navigationTreeLink.url) !== null && _navigationTreeLink_url !== void 0 ? _navigationTreeLink_url : "",
                className: classNames(navigationLinkWrapper),
                "aria-current": navigationTreeLink.selected ? "page" : undefined,
                onClick: function() {
                    var _navigationTreeLink_identifier;
                    return trackCategoriesSideNavigationClick((_navigationTreeLink_identifier = navigationTreeLink.identifier) !== null && _navigationTreeLink_identifier !== void 0 ? _navigationTreeLink_identifier : "");
                },
                ref: viewRef,
                onMouseEnter: function() {
                    return prefetchOnMouseEnter(navigationTreeLink.url);
                },
                onTouchStart: function() {
                    return prefetchOnTouchStart(navigationTreeLink.url);
                },
                onMouseLeave: clearPrefetchTimeoutOnBlur,
                children: /*#__PURE__*/ _jsx(Typography, {
                    className: navigationLinkText,
                    variant: navigationTreeLink.selected ? "paragraphSansMedium" : "paragraphSansRegular",
                    style: assignInlineVars(_define_property({}, navigationLinkBorderBottom, navigationTreeLink.selected ? "1px solid ".concat(Core.border.default) : "1px solid transparent")),
                    children: (_navigationTreeLink_name = navigationTreeLink.name) !== null && _navigationTreeLink_name !== void 0 ? _navigationTreeLink_name : ""
                })
            }),
            navigationTreeLink.children.length ? /*#__PURE__*/ _jsx("ul", {
                className: subCategoriesLinkWrapper,
                children: navigationTreeLink.children.map(function(child) {
                    return /*#__PURE__*/ _jsx("li", {
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ _jsx(SDUIFilterablePaginatedSectionNavigationLink, {
                            navigationTreeLink: child
                        })
                    }, child.identifier);
                })
            }) : null
        ]
    });
};
